var HoverSignature = require('../signature/hoverSignature'),
    HoverGraphicStamp = require('../graphicStamp/hoverShape'),
    HoverTextStamp = require('../textStamp/hoverTextStamp');


module.exports = function( note, paper, channel ) {

    var HoverShapeConstructor;

    if ( note.isSignature() )
    {
        HoverShapeConstructor = HoverSignature;
    }
    else if ( note.isGraphicStamp() ) {
        HoverShapeConstructor = HoverGraphicStamp;
    }
    else if ( note.isTextStamp() )
    {
        HoverShapeConstructor = HoverTextStamp;
    }


    // Note: was using this.lastMousePosition (set on mousemove) instead of 0 for x,y
    // ( if it persisted ) to persist position between canvas re-renders but have since removed logic,
    // as it wasn't important and had it's own problems.
    var baseOptions = {
        note: note,
        paper: paper,
        channel: channel,
        originalScale: channel.request('currentScaleValue')
    };

    return new HoverShapeConstructor( baseOptions );


};


/*****************
 ** WEBPACK FOOTER
 ** ./assets/js/modules/canvas/views/shape/hoverShape/hoverShapeFactory.js
 ** module id = 381
 ** module chunks = 0
 **/